/* import __COLOCATED_TEMPLATE__ from './card-summary-list.hbs'; */
import Component from '@glimmer/component';
export default class CardSummaryList extends Component {}